import { THREE, MeshLine } from '@/three/three.js'
import { Colors, Materials } from '@/three/colors.js'

export const threeHelpers = {
  data () {
    return {

    }
  },
  created () {

  },
  methods: {
    makeSphere (radius, trans, material) {
      const geometry = new THREE.SphereGeometry(radius, 32, 32)
      const mat = material || new THREE.MeshBasicMaterial({ color: Colors.black })
      const sphere = new THREE.Mesh(geometry, mat)
      if (trans) geometry.translate(trans.x, trans.y, trans.z)
      return sphere
    },
    makeMesh (geometry) {
      let material = new THREE.MeshLambertMaterial({
        color: 0xffffff,
        side: THREE.DoubleSide,
        vertexColors: THREE.FaceColors,
      })
      // let material = new THREE.MeshNormalMaterial()
      material.opacity = 0.85
      material.flatSharing = true
      material.transparent = true
      const meshCube = new THREE.Mesh(geometry, material)
      return meshCube
    },
    makeCube (xUnits, yUnits, zUnits, trans) {
      const DENSITY = 50 // 500 len cube = 10 Cells
      let geometry = new THREE.BoxGeometry(
        xUnits, yUnits, zUnits,
        xUnits / DENSITY, yUnits / DENSITY, zUnits / DENSITY
      )
      if (trans) geometry.translate(trans.x, trans.y, trans.z)
      // geometry.faces = geometry.faces.filter(f => f.normal.y !== 1)
      let material = new THREE.MeshBasicMaterial({
        color: Colors.white,
        vertexColors: THREE.FaceColors,
        side: THREE.DoubleSide,
      })
      const meshCube = new THREE.Mesh(geometry, material)
      return meshCube
    },
    makeWireframe (geometry) {
      let wireGeometry = new THREE.WireframeGeometry(geometry)
      const lineMaterial = new THREE.LineBasicMaterial({ color: Colors.black, linewidth: 2 })
      var lineSegments = new THREE.LineSegments(wireGeometry, lineMaterial)
      lineSegments.material.opacity = 0.25
      lineSegments.material.transparent = true
      return lineSegments
    },
    makeMeshLine (geometry) {
      var meshLine = new MeshLine.MeshLine()
      meshLine.setGeometry(geometry, (p) => 5)
      var meshMat = new MeshLine.MeshLineMaterial({ color: Colors.abb })
      var mesh = new THREE.Mesh(meshLine.geometry, meshMat)
      return mesh
    },
    makeEdge (geometry) {
      const edgesGeometry = new THREE.EdgesGeometry(geometry, 1)
      const lineMaterial = new THREE.LineBasicMaterial({ color: 0x666666 })
      const edges = new THREE.LineSegments(edgesGeometry, lineMaterial)
      return edges
    },
    makePlane (width, length, trans) {
      let geometry = new THREE.PlaneGeometry(width, length, 1)
      if (trans) geometry.translate(trans.x, trans.y, trans.z)
      let planeMesh = new THREE.Mesh(geometry, Materials.white)
      return planeMesh
    },
    pointsFromFace (face, vertices) {
      return [
        vertices[face.a],
        vertices[face.b],
        vertices[face.c],
      ]
    },
    getCentroid (...points) {
      return new THREE.Vector3(
        points.map(p => p.x).reduce((a, b) => a + b) / points.length,
        points.map(p => p.y).reduce((a, b) => a + b) / points.length,
        points.map(p => p.z).reduce((a, b) => a + b) / points.length,
      )
    },
    getSiblingFaceIndex (faceIndex) {
      // Take advantage that triangles within a square cell are always 0-1, 2-3, etc.
      return faceIndex % 2 === 0 ? faceIndex + 1 : faceIndex - 1
    },
    getAngleBetweenThreePoints (p1, p2, p3) {
      let moveOne = new THREE.Vector3().subVectors(p1, p2)
      let moveTwo = new THREE.Vector3().subVectors(p2, p3)
      return moveOne.angleTo(moveTwo)
    }
  }
}
